import { RouterModule, Routes } from '@angular/router';
import { IncidentFormComponent } from './incident-form.component';

const routes: Routes = [
	{ path: '', component: IncidentFormComponent },
];


export const incidentFormRoutes = RouterModule.forChild(routes);